import environment from '@/environment';
import { createHeaders, networkRequest } from '@/api/api-utils';
import { quoteState as quoteStateSchema, type QuoteState } from '@/schemas/quoteResponseSchema';

export const updateCoverage = async (
  quoteState: Pick<QuoteState, 'coverages' | 'invoice_period'>,
  options?: { signal?: AbortSignal; keepalive?: boolean }
): Promise<QuoteState> => {
  const payload = {
    quote_state: {
      coverages: quoteState.coverages,
      invoice_period: quoteState.invoice_period,
    },
  };
  const url = new URL('coverage/update', environment.serverBaseUrl);
  const request = new Request(url, {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify(payload),
    signal: options?.signal,
    keepalive: options?.keepalive,
  });

  const responseData = await networkRequest(request);
  return quoteStateSchema.parse(responseData);
};
